import React, { useState, useContext } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Navigation from "../components/navigation"
import AboutSection from "../components/about-section"
import AboutNav from "../components/about-nav"
import useRedirectToLang from "../hooks/useRedirectToLang"
import { ViewportContext } from "../contexts/viewport-context"

const AboutPage = () => {
  useRedirectToLang("/en/about")
  const [pageNavigationState, setPageNavigationState] = useState("we")
  const dimensions = useContext(ViewportContext)

  const pageNavigation = ["we", "philosophy", "locations", "team", "csr"]

  const handleButtonClick = index => {
    if (pageNavigation[index] !== pageNavigationState) {
      setPageNavigationState(pageNavigation[index])
      if (window.innerWidth < 641) {
        window.scrollTo(0, 0)
      }
    }
  }

  return (
    <>
      <SEO title="About" lang="en" />
      <Layout width={dimensions[0]}>
        <AboutNav
          navState={pageNavigationState}
          buttonClick={handleButtonClick}
          lang="en"
          width={dimensions[0]}
        />
        <AboutSection
          navState={pageNavigationState}
          lang="en"
          dimensions={dimensions}
        />
      </Layout>
      <Navigation path="/en/about" lang="en" width={dimensions[0]} />
    </>
  )
}

export default AboutPage
